// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"599f76a2","960":"ba706508"}[chunkId] + ".chunk.js";
};